module.exports = __webpack_public_path__ + "static/img/banner2.967da7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner2.jpg
// module id = CDl+
// module chunks = 1